import React from 'react';
import { useNavigate } from 'react-router-dom';
//import { CommonInnerSidebar } from '../../common/common-inner-sidebar/commonInnerSidebar';
import { Container, Box, Stack, Typography, Dialog, DialogContent, DialogActions, Tab, Card, Button, IconButton, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import './biddingApproval.css';
import { authKey, DOWNLOAD_DOCUMENT, GET_BIDDING_SCHEDULE_APPROVAL, APPROVE_SCHEDULES_FOR_BIDDING, GET_BIDDING_SCHEDULE_SELECTION, GET_BIDDING_DETAILS } from '../../../common/URLs';
import { useState, useEffect } from 'react';
import { loaderService } from '../../../common/custom-loader/loader-service';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";

import { PROD, PIT_ROLES } from "../../../common/constants";
import moment from 'moment';
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { toast } from 'react-toastify';
import { userData, uuid } from '../../../common/spinLoader';
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { FileIcon, ViewIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function BiddingApproval() {

    const navigate = useNavigate();
    const [biddingScheduleApprovalData, setBiddingScheduleApprovalData] = useState();
    const [approvalList, setApprovalList] = useState([]);
    const [approveButtonDetails, setApproveButtonDetails] = useState();
    const [approvedSchedulesForBidding, setApprovedSchedulesForBidding] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => { setLogModalOpen2(false); getBiddingScheduleApproval(); }
    const [tabValue, setTabValue] = useState("schedules");
    const userLoggedIn = userData?.user?.userRoles?.[0].roleName

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
        loaderService.showLoader();
        return fetch(DOWNLOAD_DOCUMENT,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": documentBlobName,
                    "containerName": "pit",
                    "file": ""
                })
            })
            .then((response) => response.blob()
            )
            .then((blob) => {
                if (type === "View") {
                    const fileName = finalfileName
                    const splittedName = fileName.split('.')
                    const fileExtension = splittedName[splittedName.length - 1];
                    let fileType;
                    switch (fileExtension) {
                        case 'pdf':
                            fileType = 'application/pdf';
                            break;
                        case 'png':
                            fileType = 'image/png';
                            break;
                        case 'jpg':
                            fileType = 'image/jpeg';
                            break;
                        case 'jpeg':
                            fileType = 'image/jpeg';
                            break;
                        default:
                            fileType = 'application/octet-stream';
                    }
                    const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                    const newWindow = window.open(url, '_blank');
                    newWindow.focus();
                }
                else {
                    const a = document.createElement("a");
                    a.style.display = "none";
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = finalfileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    // const viewanddownloadDocument = (fileName, containerName, finalfileName) => {
    //     // e.preventDefault();
    //     viewdownloadDocument(biddingScheduleApprovalData?.biddingTermsFileId, "pit", biddingScheduleApprovalData?.biddingTermsFileName)
    // }

    const onViewDetails = (row) => {
        navigate('./biddingDetails', {
            state: { selectedRow: row, tabVal: tabValue }
        });
    }

    const columns = [
        { field: 'allotmentRequestNumber', headerName: 'Request Number', width: 180 },
        // {
        //     field: 'schedulePickupDate', headerName: 'PickUp Date', type: 'date', width: 120,
        //     valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        // },
        { field: 'allotmentQuantity', headerName: 'Quantity(MT)', type: 'number', width: 150 },
        // { field: 'uom', headerName: 'UOM', width: 80 },
        // { field: 'firstPartyUrn', headerName: 'URN(1stParty)', width: 150},
        // { field: 'firstPartyContactNo', headerName: 'Contact Details(1stParty)', width: 170},
        { field: 'firstPartyLocationAddress', headerName: 'Origin', width: 130 },
        // { field: 'secondPartyUrn', headerName: 'URN(2ndParty)', width: 130},
        // { field: 'secondPartyContactNo', headerName: 'Contact Details(2ndParty)', type: 'number', width: 180},
        { field: 'secondPartyLocationAddress', headerName: 'Destination', width: 140 },
        // {
        //     field: 'scheduledDeliveryDate', headerName: 'Delivery Date', type: 'date', width: 120,
        //     valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        // },
        // { field: 'poStpoNumber', headerName: 'PO Number', width: 110},
        {
            field: 'materialType', headerName: 'Material Type', width: 150,
            valueFormatter: (params) => {
                if (params.value === 'CB') {
                    return 'Chipped bamboo';
                }
                else if (params.value === 'RB') {
                    return 'Raw bamboo';
                }
            }
        },

        { field: 'baseBidPrice', headerName: 'Base Rate(per ton per KM)', type: 'number', width: 150,
            valueGetter: params => params?.value?.toFixed(2),
         },
        {
            field: 'biddingStartDate', headerName: 'Bidding Start Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'biddingEndDate', headerName: 'Bidding End Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'viewaction', headerName: 'Action', width: 180,
            renderCell: (params) => (
                <>
                    <Tooltip title="View Document">
                        <IconButton color="primary" sx={{ minWidth: 70 }} variant="contained" disabled={params?.row?.biddingTermsFileId === null} onClick={(e) => viewdownloadDocument(params?.row?.biddingTermsFileId, params?.row?.biddingTermsFileName, "Download")} >{params?.row?.biddingTermsFileId === null ? "" : <FileIcon />}</IconButton>
                    </Tooltip>
                    <Tooltip title="View">
                        <IconButton color="primary" variant="contained" sx={{ minWidth: 70 }} onClick={() => onViewDetails(params?.row)}><ViewIcon /></IconButton>
                    </Tooltip>
                </>
            )
        }
    ];

    useEffect(() => {
        getBiddingScheduleApproval();
    }, []);

    const getBiddingScheduleApproval = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_BIDDING_SCHEDULE_APPROVAL,
                {

                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setBiddingScheduleApprovalData(response.data.weeklySchedulePlanDetailsList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };



    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        if (newValue === "approve") {
            if (userLoggedIn === PIT_ROLES.PitApprover) getBiddingDetails();
            else if (userLoggedIn === PIT_ROLES.TransportationIncharge) getBiddingScheduleSelection(newValue);
        }
    }
    const getBiddingScheduleSelection = (newValue) => {
        loaderService.showLoader();
        apiClient
            .post(GET_BIDDING_SCHEDULE_SELECTION,
                {
                    "type": newValue
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token')
                    },
                },
                null
            ).then((response) => {
                setApprovedSchedulesForBidding(response.data.weeklySchedulePlanDetailsList);
                console.log(approvedSchedulesForBidding);
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });

    };
    // useEffect(() => {
    //     if(userLoggedIn === PIT_ROLES.PitApprover) getBiddingDetails();
    //     else if(userLoggedIn === PIT_ROLES.PitApprover) 
    // }, []);

    const getBiddingDetails = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_BIDDING_DETAILS,
                {

                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            ).then((response) => {
                setApprovedSchedulesForBidding(response.data.spotBiddingAllotmentRequestDetailsList);
                console.log(response.data.spotBiddingAllotmentRequestDetailsList);
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const onConfirmApprove = (e) => {
        handleConfirmClose();
        onApproveButton();
        // onApprove(e);
    }

    const onApproveButtonClick = (e) => {
        handleConfirmOpen();
    }

    const onApproveButton = () => {
        console.log(approvalList);
        loaderService.showLoader();
        apiClient
            .post(
                APPROVE_SCHEDULES_FOR_BIDDING,
                {
                    "schedule_Id": approvalList
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setApproveButtonDetails(response.data);
                getBiddingScheduleApproval();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (approveButtonDetails) {
            if (approveButtonDetails.isSuccess === true) {
                toast.success(approveButtonDetails?.message)
                // handleLogModalOpen2();
            } else {
                toast.error(approveButtonDetails?.message ? approveButtonDetails?.message : "Error")
                // handleLogModalOpen();
            }
        }
    }, [approveButtonDetails]);

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT43</p>}
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Bidding Schedule Confirm
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                        <>
                            <Stack direction="row" spacing={1}>
                                <Button sx={{ minWidth: 100 }} variant="contained" hidden={tabValue == 'approve'} disabled={approvalList?.length < 1} onClick={() => onApproveButtonClick()} startIcon={<ApproveIcon />}>
                                    Confirm
                                </Button>
                            </Stack>
                        </>

                    </Stack>
                </Stack>
                <Card>
                    <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
                            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                <Tab label="Schedules for Bidding" value="schedules" />
                                <Tab label="Confirmed schedules for Bidding" value="approve" />
                            </TabList>
                        </Box>
                        <TabPanel value="schedules">
                            <Card>
                                <Box sx={{ height: 400, width: "100%" }}>
                                    {
                                        biddingScheduleApprovalData &&
                                        <DataGrid
                                            rows={biddingScheduleApprovalData}
                                            columns={columns}
                                            rowsPerPageOptions={[10]}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                            experimentalFeatures={{ newEditingApi: true }}
                                            checkboxSelection
                                            onSelectionModelChange={(newSelection) => {
                                                setApprovalList(newSelection.map(row => {
                                                    let sno = ""
                                                    biddingScheduleApprovalData.forEach(sch => {
                                                        if (row == sch.id) {
                                                            sno = sch.id;
                                                        }
                                                    })
                                                    return sno;
                                                }));
                                            }} />
                                    }
                                </Box>
                            </Card>
                            {/* {biddingScheduleApprovalData?.length !== 0 ?
                            <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                                <Button sx={{ minWidth: 100 }} variant="contained" onClick={() => onApproveButton()}>Confirm</Button>
                            </Box>
                            : null} */}
                        </TabPanel>
                        <TabPanel value="approve">
                            <Card>
                                <Box sx={{ height: 400, width: "100%" }}>
                                    {approvedSchedulesForBidding &&
                                        <DataGrid
                                            rows={approvedSchedulesForBidding}
                                            columns={columns}
                                            pageSize={10}
                                            rowsPerPageOptions={[10]}
                                            components={{ Toolbar: QuickSearchToolbar }} />
                                    }
                                </Box>
                            </Card>
                        </TabPanel>
                    </TabContext>
                </Card>

            </Container>

            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Confirm" />

            <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
                <DialogContent>
                    <ConfirmPopover title={approveButtonDetails?.message ? approveButtonDetails?.message : "Error"} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose2}>OK</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default BiddingApproval;